module.exports = __webpack_public_path__ + "static/media/loading.5e282b60.gif";